export const plState = (state) => state.pl;

export const getLoadingPL = (state) => plState(state).loading;

export const getPlLoaded = (state) => plState(state).pl;


export const getResponsePL = (state) => plState(state).response;
